// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_PRODUCTS */
/* CRIO_SOLUTION_END_MODULE_PRODUCTS */
.card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-actions {
    margin-bottom: 1rem;
}

.card-button {
    text-transform: none;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductCard.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,sCAAsC;AACtC;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_PRODUCTS */\n/* CRIO_SOLUTION_END_MODULE_PRODUCTS */\n.card {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.card-actions {\n    margin-bottom: 1rem;\n}\n\n.card-button {\n    text-transform: none;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
